"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _categories = require("@insided/shared/utils/categories");

var _NestedDropdown = _interopRequireDefault(require("@insided/shared/uikit/NestedDropdown"));

var _SearchBox = _interopRequireDefault(require("@insided/deprecated-preact-components/search-box/SearchBox"));

var _dropdown = _interopRequireDefault(require("@insided/shared/uikit/dropdown"));

var _NestedDropdownHeader = _interopRequireDefault(require("@insided/shared/uikit/NestedDropdown/NestedDropdownHeader"));

var _ChevronUp = _interopRequireDefault(require("@insided/shared/icons/ChevronUp"));

var _ChevronDown = _interopRequireDefault(require("@insided/shared/icons/ChevronDown"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _Tooltip = _interopRequireDefault(require("@insided/shared/uikit/Tooltip"));

var _Block = _interopRequireDefault(require("@insided/shared/icons/Block"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var getDefaultExpandedDropdowns = function getDefaultExpandedDropdowns(items) {
  var expandedDropdowns = {};
  Object.keys(items).forEach(function (moduleType) {
    expandedDropdowns[moduleType] = true;
  });
  return expandedDropdowns;
};

var CategorySelect = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(CategorySelect, _Component);

  var _super = _createSuper(CategorySelect);

  function CategorySelect() {
    var _this$props$categorie;

    var _this;

    (0, _classCallCheck2.default)(this, CategorySelect);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "searchInputRef", (0, _preact.createRef)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      categories: (_this$props$categorie = _this.props.categories) !== null && _this$props$categorie !== void 0 ? _this$props$categorie : {},
      closeOnDropdownClick: true,
      searchValue: '',
      expandedDropdowns: getDefaultExpandedDropdowns(_this.props.categories)
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "findCategoryById", function (categoryId, searchCategories) {
      var categories = searchCategories !== null && searchCategories !== void 0 ? searchCategories : Object.values(_this.state.categories).flat();

      var _iterator = _createForOfIteratorHelper(categories),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _category = _step.value;
          if (_category.id === categoryId) return _category;
          if (!_category.children) continue;

          var foundCategory = _this.findCategoryById(categoryId, _category.children);

          if (foundCategory) return foundCategory;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return null;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSelectCategory", function (categoryId) {
      if (!categoryId) return;

      var category = _this.findCategoryById(categoryId);

      if (!category || category.isContainer) return;

      _this.props.onSelectCategory(category);

      _this.setState({
        closeOnDropdownClick: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onToggleCollapse", function (categoryId) {
      _this.setState(function (_ref) {
        var categories = _ref.categories;
        return {
          categories: (0, _categories.collapseCategory)(categories, categoryId),
          closeOnDropdownClick: false
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSearchInputHandler", function (e) {
      var target = e.target;

      _this.setState({
        searchValue: target.value,
        closeOnDropdownClick: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSearchClearHandler", function () {
      _this.setState({
        searchValue: '',
        closeOnDropdownClick: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getFilteredCategories", function () {
      var _this$state = _this.state,
          categories = _this$state.categories,
          searchValue = _this$state.searchValue;

      if (!searchValue) {
        return categories;
      }

      var filteredCategories = {};
      Object.entries(categories).forEach(function (_ref2) {
        var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
            key = _ref3[0],
            categoryList = _ref3[1];

        var filtered = (0, _categories.filterCategoriesByTitle)(JSON.parse(JSON.stringify(categoryList)), searchValue);

        if (filtered.length > 0) {
          filteredCategories[key] = filtered;
        }
      });
      return filteredCategories;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onOpenDropdown", function () {
      var _this$searchInputRef$;

      (_this$searchInputRef$ = _this.searchInputRef.current) === null || _this$searchInputRef$ === void 0 ? void 0 : _this$searchInputRef$.focus();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleKeyDown", function (e) {
      if (e.key === 'Enter') {
        _this.onOpenDropdown();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleDropdown", function (module) {
      _this.setState(function (prevState) {
        var _prevState$expandedDr;

        return {
          expandedDropdowns: _objectSpread(_objectSpread({}, prevState.expandedDropdowns), {}, (0, _defineProperty2.default)({}, module, !((_prevState$expandedDr = prevState.expandedDropdowns[module]) !== null && _prevState$expandedDr !== void 0 ? _prevState$expandedDr : false))),
          closeOnDropdownClick: false
        };
      });
    });
    return _this;
  }

  (0, _createClass2.default)(CategorySelect, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(previousProps) {
      if (JSON.stringify(previousProps.categories) !== JSON.stringify(this.props.categories)) {
        this.setState({
          categories: this.props.categories
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          trigger = _this$props.trigger,
          triggerClass = _this$props.triggerClass,
          _this$props$searchabl = _this$props.searchable,
          searchable = _this$props$searchabl === void 0 ? false : _this$props$searchabl,
          _this$props$searchPla = _this$props.searchPlaceholder,
          searchPlaceholder = _this$props$searchPla === void 0 ? 'Search for category or group' : _this$props$searchPla,
          removeCategoryOption = _this$props.removeCategoryOption;
      var _this$state2 = this.state,
          closeOnDropdownClick = _this$state2.closeOnDropdownClick,
          searchValue = _this$state2.searchValue,
          expandedDropdowns = _this$state2.expandedDropdowns;
      var filteredCategories = this.getFilteredCategories();
      var hasMultipleModules = Object.keys(filteredCategories).length > 1;
      var hasResults = Object.keys(filteredCategories).length > 0;
      return (0, _preact.h)("div", {
        onClick: this.onOpenDropdown,
        onKeyDown: this.handleKeyDown,
        role: "button",
        tabIndex: 0,
        className: "category-dropdown-wrapper"
      }, (0, _preact.h)(_dropdown.default, {
        closeOnDropdownClick: closeOnDropdownClick,
        popupName: "category-selector",
        className: "dropdown-selector category-selector",
        trigger: trigger,
        triggerClass: triggerClass
      }, removeCategoryOption && (0, _preact.h)("div", {
        className: "remove-category-header"
      }, (0, _preact.h)(_Tooltip.default, {
        position: "left",
        verticalPosition: "top",
        noWrap: true,
        tooltipMessage: removeCategoryOption.tooltip,
        trigger: (0, _preact.h)(_Button.default, {
          title: "Remove category",
          startIcon: (0, _preact.h)(_Block.default, {
            width: 16,
            height: 16
          }),
          className: "remove-category-option",
          size: "medium",
          fullWidth: true,
          disabled: removeCategoryOption.disabled,
          onClick: function onClick() {
            removeCategoryOption.onClick();

            _this2.setState({
              closeOnDropdownClick: true
            });
          },
          "data-track-type": "click",
          "data-element-name": "Remove category button"
        })
      }), (0, _preact.h)("div", {
        className: "remove-category-separator"
      })), (0, _preact.h)("div", {
        className: "category-dropdown-scrollable"
      }, searchable && (0, _preact.h)("div", {
        className: "category-dropdown-search"
      }, (0, _preact.h)(_SearchBox.default, {
        isModerationOverview: true,
        placeholder: searchPlaceholder,
        value: searchValue,
        onSubmit: function onSubmit() {},
        onInput: this.onSearchInputHandler,
        onClear: this.onSearchClearHandler,
        searchInputRef: this.searchInputRef
      })), searchable && !hasResults && searchValue && (0, _preact.h)("div", {
        className: "category-dropdown-no-results"
      }, "No results found"), hasResults && Object.entries(filteredCategories).map(function (_ref4) {
        var _expandedDropdowns$ke;

        var _ref5 = (0, _slicedToArray2.default)(_ref4, 2),
            key = _ref5[0],
            value = _ref5[1];

        var categoryName = (0, _categories.getModuleNameFromType)(parseInt(key));
        var isExpanded = (_expandedDropdowns$ke = expandedDropdowns[key]) !== null && _expandedDropdowns$ke !== void 0 ? _expandedDropdowns$ke : true;
        return (0, _preact.h)("div", {
          key: categoryName
        }, hasMultipleModules && (0, _preact.h)(_NestedDropdownHeader.default, null, (0, _preact.h)("div", {
          role: "button",
          tabIndex: 0,
          "aria-expanded": isExpanded,
          "aria-controls": "dropdown-panel-".concat(key),
          onClick: function onClick() {
            return _this2.toggleDropdown(key);
          },
          onKeyDown: function onKeyDown(e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();

              _this2.toggleDropdown(key);
            }
          },
          className: "dropdown-selector__header-wrapper"
        }, (0, _preact.h)("span", null, categoryName), (0, _preact.h)("span", {
          "aria-hidden": "true"
        }, isExpanded ? (0, _preact.h)(_ChevronUp.default, null) : (0, _preact.h)(_ChevronDown.default, null)))), isExpanded && (0, _preact.h)(_NestedDropdown.default, {
          items: value,
          onSelectItem: _this2.onSelectCategory,
          depth: 1,
          onToggleCollapse: _this2.onToggleCollapse,
          isCategoryDropdown: true
        }));
      }))));
    }
  }]);
  return CategorySelect;
}(_preact.Component);

var _default = CategorySelect;
exports.default = _default;